module.exports = __webpack_public_path__ + "img/crossbow.f0e33040.png";